
















import { defineComponent, reactive } from '@vue/composition-api';

import useDownloadReport from '@/useDownloadReport';

const AreaPercentTReport = defineComponent({
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      range: {
        from: undefined,
        to: undefined,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default AreaPercentTReport;
